/* eslint-disable class-methods-use-this */
import React, { useState } from "react";

import PageWrapper from "Components/Pages/Wrapper";

import { useQueryParams } from "Hooks/useQueryParams";
import Input from "Components/Form/Input";
import { Formik, Form, Field } from "formik";
import { resetPasswordAPI } from "Requests/Auth";
import * as Yup from "yup";
import { Button } from "Components/Button";
import { Box } from "styles/globalComponents";
import { Loader } from "Components/Loader";
import { createToast } from "Utils/toastFunc";
import { useHistory } from "react-router";

export const schema = Yup.object({
  password: Yup.string()
    .min(6, "A senha deve ter no mínimo 6 caracteres")
    .required("Senha é obrigatória"),
  confirmPassword: Yup.string()
    .required("Confirmação de senha é obrigatória")
    .when("senha", (senha, schema) =>
      senha ? schema.oneOf([senha], "As senhas devem coincidir") : schema
    ),
});

export const PasswordRecovery = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const query = useQueryParams();
  const login = query.get("login");
  const token = query.get("token");

  const handleResetPassword = async (data: {
    password: string;
    confirmPassword: string;
  }) => {
    setLoading(true);
    try {
      if (login && token) {
        const resetData = {
          email: login,
          token,
          password: data.password,
          password_confirmation: data.confirmPassword,
        };

        await resetPasswordAPI(resetData);
        createToast("success", "Senha redefinida com sucesso");
        setTimeout(() => {
          history.push("/login");
        }, 1000);
      }
    } catch (error) {
      createToast("success", "Senha redefinida com sucesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper className="">
      <div className="container">
        <div className="app-auth-panel">
          <div className="panel-header">
            <h3 className="text-purple text-no-margin">Recuperar senha</h3>
          </div>

          <Formik
            initialValues={{
              password: "",
              confirmPassword: "",
            }}
            onSubmit={handleResetPassword}
            validationSchema={schema}
          >
            {({ values, handleChange, touched, errors }) => {
              return (
                <Form>
                  <div className="md-12">
                    <Field
                      label="Nova senha"
                      id="password"
                      type="password"
                      value={values.password}
                      component={Input}
                      onChange={handleChange}
                      placeholder="Nova senha"
                      error={
                        touched.password && errors.password && errors.password
                      }
                    />
                  </div>
                  <div className="md-12">
                    <Field
                      label="Confirme nova senha"
                      id="confirmPassword"
                      type="password"
                      value={values.confirmPassword}
                      component={Input}
                      onChange={handleChange}
                      placeholder="Confirme a nova senha"
                      error={
                        touched.confirmPassword &&
                        errors.confirmPassword &&
                        errors.confirmPassword
                      }
                    />
                  </div>

                  <Box display="flex" justify="center">
                    <Button
                      type="submit"
                      padding="10px 40px"
                      borderRadius="8"
                      disabled={loading}
                    >
                      {loading ? <Loader size={15} /> : "Confirmar"}
                    </Button>
                  </Box>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </PageWrapper>
  );
};

export default PasswordRecovery;
